export default "__VITE_ASSET__D2C7PlNr__"